import { onError } from '@apollo/client/link/error';
import { OperationDefinitionNode } from 'graphql';

import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { EnvUtils } from '@/utils/env.utils';
import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { CustomEventTypes } from '@/config/LogEventTypes.config';
import { RedirectionHelpers } from '../helpers/RedirectionHelpers';

export const redirectOnPage404Link = onError(({ forward, operation, graphQLErrors }) => {
  if (!graphQLErrors?.length) {
    return forward(operation);
  }

  graphQLErrors.forEach(({ extensions }) => {
    const currentUrl = window.location.href;
    const operationType = (operation.query.definitions[0] as OperationDefinitionNode)?.operation;
    const errorCode = extensions?.code as string | undefined;
    const context = operation.getContext();

    const shouldRedirect = RedirectionHelpers.shouldRedirectTo404Page(operationType, errorCode);

    if (shouldRedirect && EnvUtils.isProduction()) {
      appInsights.trackEvent({ name: CustomEventTypes.REDIRECT_TO_PAGE_404 }, {
        urlFromRedirected: currentUrl,
        subscriptionid: context?.headers?.subscriptionid ?? null,
        organisationid: context?.headers?.organisationid ?? null,
      });
    }

    if (shouldRedirect) {
      browserHistory.push(getParameterizedLink('/not-found'));
    }
  });

  return undefined;
});
